import { TableCell, Tooltip } from "@mui/material";

export const TooltipCell = ({
    children,
    title,
    align = 'left',
    className,
    style
}: {
    children: React.ReactNode;
    title: string | number | React.ReactNode;
    align?: 'left' | 'center' | 'right';
    className?: string;
    style?: React.CSSProperties;
}) => (
    <Tooltip
        placement='top'
        title={title}
        enterDelay={1000}
        enterNextDelay={1000}
        leaveDelay={200}
        disableInteractive
        slotProps={{
            popper: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -30],
                        },
                    },
                ],
            },
        }}
    >
        <TableCell align={align} className={className} style={style}>
            {children}
        </TableCell>
    </Tooltip>
);
